import React, { useState } from "react";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import CustomModal from "../../../../components/common/Modal";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
   addSingleFleetChildAsync,
   fetchSingleFleetAsync,
   listFleetAsync,
   updateSingleFleetChildAsync,
} from "../../../../redux/features/fleetMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import CustomTable from "../../../../components/common/CustomTable";
import { BsPencilSquare } from "react-icons/bs";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
   MAX_FILE_SIZE,
   MAX_FILE_SIZE_MESSAGE,
   isValidFileType,
} from "../../../../helpers/fileValidationRules";
import { MAX_DATE } from "../../../../Hooks/dateValidationRules";
import MultipleFileUpload from "../../../../components/common/MultipleFileUpload/MultipleFileUpload";

const validationSchema = Yup.object().shape({
   odometerReading: Yup.number().required("Odometer Reading is required"),
   serviceDate: Yup.date()
      .required("Service Date is required")
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   serviceAmount: Yup.number().required("Service Amount is required"),
   serviceStationName: Yup.string().required("Service Station Name is required"),
   existingServiceBillUpload: Yup.string(),
   serviceBillUpload: Yup.array()
      .of(
         Yup.mixed()
            .required("Service Bill is required")
            .test("is-valid-type", "Not a valid document type", (value) => {
               if (value && typeof value === "string") return true;
               return isValidFileType(value && value.name.toLowerCase(), "all");
            })
            .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
               if (value && typeof value === "string") return true;
               return value && value.size <= MAX_FILE_SIZE;
            }),
      )
      .when("existingServiceBillUpload", {
         is: (existingServiceBillUpload) => !existingServiceBillUpload,
         then: (schema) => {
            return schema.min(1, "Service Bill is required");
         },
         otherwise: (schema) => {
            return schema.min(0);
         },
      }),
});

const initialValues = {
   id: "",
   odometerReading: "",
   serviceDate: "",
   serviceAmount: "",
   serviceStationName: "",
   serviceBillUpload: [],
   existingServiceBillUpload: "",
   removedServiceBillUpload: "",
};

function ServiceRecord({ serviceBillAdd }) {
   const params = useParams();
   const dispatch = useDispatch();

   const [action, setAction] = useState("");

   const [isModalVisible, setIsModalVisible] = useState(false);
   const handleShowModal = () => {
      setIsModalVisible(true);
   };
   const handleCloseModal = () => {
      setIsModalVisible(false);
   };

   const columns = [
      {
         name: "Odometer Reading",
         selector: (row) => row.odometerReading,
      },
      {
         name: "Service Amount",
         selector: (row) => row.serviceAmount,
         sortable: true,
      },
      {
         name: "Service Date",
         selector: (row) => row.serviceDate,
         sortable: true,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => row.action,
      },
   ];

   const data = serviceBillAdd?.map((item) => ({
      ...item,
      action: (
         <button
            className="btn"
            onClick={() => {
               setAction("edit");
               setValues({
                  id: item?.id,
                  odometerReading: item?.odometerReading,
                  serviceDate: item?.serviceDate,
                  serviceAmount: item?.serviceAmount,
                  serviceStationName: item?.serviceStationName?.toString(),
                  serviceBillUpload: [],
                  existingServiceBillUpload: item?.serviceBillUpload,
               });
               handleShowModal();
            }}
            type="button"
         >
            <BsPencilSquare
               className="text-primary"
               style={{ height: "1.5rem", width: "1.5rem" }}
            />
         </button>
      ),
   }));

   const handleAddOrUpdateServiceRecord = (formData) => {
      // setFieldError("serviceBillUpload", "rljfvbkjbkjh");

      // return;
      const newData = new FormData();

      const data = {
         fleet_master_id: params?.id,
         model_id: 3,
         service_record_id: formData?.id,
      };
      const dataArr = {
         service_record_odometer_reading: [formData.odometerReading],
         service_date: [formData.serviceDate],
         service_amount: [formData.serviceAmount],
         service_station_name: [formData.serviceStationName],
      };

      Object.keys(data).forEach((item) => {
         newData.append(item, data[item]);
      });
      Object.keys(dataArr).forEach((item) => {
         newData.append(`${item}[]`, JSON.stringify(dataArr[item]));
      });

      if (action === "edit") {
         newData.append("_method", "PATCH");
         newData.append("action_id", 2);
         formData.serviceBillUpload?.forEach?.((item) => {
            console.log("item", item);
            newData.append("service_bill_upload[]", item);
         });
         if (typeof formData.existingServiceBillUpload !== "string") {
            newData.append(
               "existing_service_bill_upload",
               formData.existingServiceBillUpload,
            );
         }
         newData.append("removed_service_bill_upload", formData.removedServiceBillUpload);
         // newData.forEach((value, key) => {
         //    console.log(key, value);
         // });
         // return;
         dispatch(backdropLoadingAction(true));
         dispatch(
            updateSingleFleetChildAsync({
               data: newData,
               err: () => {
                  dispatch(backdropLoadingAction(false));
                  //toast.error("Something went wrong !");
               },
               done: () => {
                  dispatch(fetchSingleFleetAsync({ id: params?.id }));
                  dispatch(backdropLoadingAction(false));
                  toast.success("Record updated successfully !");
                  handleCloseModal();
                  resetForm();
               },
            }),
         );
      }

      if (action === "add") {
         newData.append("action_id", 1);

         formData.serviceBillUpload?.forEach?.((item) => {
            newData.append("service_bill_upload[]", item);
         });

         dispatch(backdropLoadingAction(true));

         dispatch(
            addSingleFleetChildAsync({
               data: newData,
               err: () => {
                  dispatch(backdropLoadingAction(false));
                  //toast.error("Something went wrong !");
               },
               done: () => {
                  dispatch(fetchSingleFleetAsync({ id: params?.id }));
                  dispatch(backdropLoadingAction(false));
                  toast.success("Record added successfully !");
                  handleCloseModal();
                  // window.location.href = window.location.href;
                  resetForm();
               },
            }),
         );
      }
   };

   const formik = useFormik({
      initialValues,
      validationSchema,
      enableReinitialize: true,
      onSubmit: handleAddOrUpdateServiceRecord,
   });

   const {
      errors,
      touched,
      getFieldProps,
      handleSubmit,
      setValues,
      values,
      setFieldValue,
      resetForm,
      setFieldError,
      validateField,
   } = formik;

   return (
      <>
         <CustomModal
            showModal={isModalVisible}
            handleCloseModal={handleCloseModal}
            modalSize="modal-xl"
            title="Fleet"
            onSubmit={handleSubmit}
            child={
               <div
                  className="tab-pane fade show active"
                  id="2"
                  role="tabpanel"
                  aria-labelledby="2"
               >
                  <FormikProvider value={formik}>
                     <Form noValidate>
                        <div className="col-lg-12">
                           <div className="card card-primary">
                              <div className="card-header">
                                 <h3 className="card-title">Service Record</h3>
                              </div>

                              <div className="card-body">
                                 <div className={"row"}>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          require
                                          label="Odometer reading"
                                          id="odometerReading"
                                          placeholder="Enter Amount"
                                          {...getFieldProps("odometerReading")}
                                          errors={
                                             Boolean(touched.odometerReading) &&
                                             Boolean(errors.odometerReading)
                                          }
                                          message={errors.odometerReading}
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomDatePicker
                                          require
                                          label="Service Date"
                                          id="serviceDate"
                                          placeholder="Select Service Date"
                                          {...getFieldProps("serviceDate")}
                                          errors={
                                             Boolean(touched.serviceDate) &&
                                             Boolean(errors.serviceDate)
                                          }
                                          message={errors.serviceDate}
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          require
                                          label="Service Amount"
                                          id="serviceAmount"
                                          placeholder="Enter Service Amount"
                                          {...getFieldProps("serviceAmount")}
                                          errors={
                                             Boolean(touched.serviceAmount) &&
                                             Boolean(errors.serviceAmount)
                                          }
                                          message={errors.serviceAmount}
                                       />
                                    </div>
                                    <div className="col-lg-4">
                                       <CustomInput
                                          require
                                          label="Service Station Name"
                                          id="serviceStationName"
                                          placeholder="Enter Service Station Name"
                                          {...getFieldProps("serviceStationName")}
                                          errors={
                                             Boolean(touched.serviceStationName) &&
                                             Boolean(errors.serviceStationName)
                                          }
                                          message={errors.serviceStationName}
                                       />
                                    </div>
                                    <div className="col-lg-8">
                                       {/* <label className="text-bold">
                                    Service bill upload{" "}
                                    <span className="text-danger">*</span>
                                 </label> */}
                                       {/* <CustomFileUpload
                                    accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp, .png, .jpg"
                                    name={"serviceBillUpload"}
                                    value={getFieldProps("serviceBillUpload").value}
                                    onChange={(e) => {
                                       
                                       e.currentTarget?.files?.[0] &&
                                          setFieldValue(
                                             "serviceBillUpload",
                                             e.currentTarget?.files?.[0]
                                          );
                                    }}
                                    errors={
                                       Boolean(touched.serviceBillUpload) &&
                                       Boolean(errors.serviceBillUpload)
                                    }
                                    message={errors.serviceBillUpload}
                                 /> */}

                                       <MultipleFileUpload
                                          label={"Service bill upload"}
                                          onChange={(files) => {
                                             setFieldValue("serviceBillUpload", files);
                                          }}
                                          accepts={[
                                             ".pdf",
                                             ".doc",
                                             ".docx",
                                             ".csv",
                                             ".txt",
                                          ]}
                                          existingValue={values.existingServiceBillUpload}
                                          errors={Boolean(errors.serviceBillUpload)}
                                          message={errors.serviceBillUpload}
                                          value={values.serviceBillUpload}
                                          onRemoveExistingFiles={(
                                             existingValues,
                                             removedValues,
                                          ) => {
                                             setFieldValue(
                                                "existingServiceBillUpload",
                                                existingValues,
                                             );
                                             setFieldValue(
                                                "removedServiceBillUpload",
                                                removedValues,
                                             );
                                          }}
                                       />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </Form>
                  </FormikProvider>
               </div>
            }
         />

         <CustomTable columns={columns} data={data} />

         <div className="row mt-3">
            <div className="col-6">
               <button
                  type="button"
                  className="btn btn-primary float-left"
                  onClick={() => {
                     setAction("add");
                     resetForm();
                     handleShowModal();
                  }}
               >
                  <i className="fas fa-plus"></i> Add More
               </button>
            </div>
         </div>
      </>
   );
}

export default ServiceRecord;
